import { type ChatMessageStatus, OfChatMessagesService } from '@api'
import { useUnit } from 'effector-react'
import { useInfiniteQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { updateMediaDataMap } from '@/models/vault/medias'
import type { StreamableVaultMedia } from '@/modules/vault/types.ts'

interface Props {
  enabled: boolean
  status?: ChatMessageStatus
}

export const usePpvOverview = (props: Props) => {
  const creatorId = useUnit($creatorId)
  const { status, enabled } = props

  const query = useInfiniteQuery({
    queryKey: [creatorId, 'ppv-overview', status],
    queryFn: ({ pageParam = null }) =>
      OfChatMessagesService.getNextPpvMessagesWithStatus({
        creatorId,
        limit: 20,
        status,
        ...pageParam,
      }),
    getNextPageParam: (response) => {
      if (response.hasNext) {
        const lastMessage = response.content.slice(-1)[0]

        return {
          fromOfMessageId: lastMessage.onlyfansMessageId,
          fromCreatedAt: lastMessage.sentAt,
        }
      }
    },
    onSuccess: (data) => {
      // TODO: we don't need it if BE will send media ids
      updateMediaDataMap(
        data.pages.flatMap(({ content }) =>
          content.flatMap(({ media }) => {
            return (media ?? []).map(
              // @ts-ignore
              (media): StreamableVaultMedia => ({
                ...media,
                releaseForms: [],
                createdAt: '',
                listStates: [],
              }),
            )
          }),
        ),
      )
    },
    staleTime: 60000,
    enabled: !!creatorId && enabled,
    retry: false,
  })

  const ppvs = query.data?.pages.flatMap((page) => page.content) || []

  return {
    ...query,
    ppvs,
    hasMore: query.hasNextPage,
  }
}
